<template>
  <Container type="card-full">
    <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick" :btnLoading="btnLoading"></menu-btn>
    </div>
    <div style="color:red;">即将推出,敬请期待</div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import MenuBtn from "../common/menuBtn"
  export default {
    name: "zhtj",
    data () {
      return {
        menuid: this.$route.query.menuid,
        btnLoading:false
      }
    },
    activated () {
    },
    components: {MenuBtn},
    created() {
      this.$on('CLOSE', () => this.close())
    },
    mounted () {
    },
    watch: {
    },
    filters: {
    },
    methods: {
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      btnClick (code) {
        this.$emit(code)
      },
    }
  }
</script>

<style scoped>

</style>
